


<div class="backgroundImage">
  <app-header login= 'yes'></app-header>

    <div class="container">
      <div class="sin-in-page-top">
        <div class="card-wrapper">
          <div class="sin-in-contnt">
            <div class="sigin-screen-area"><span class="nav-divnk">Forgot Password</span></div>
            <div class="content-part">
              <img src="assets/logo-5.png">
            </div>
            <form class="forget-password-form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" >
              <div class="form-group">
                <input type="email" class="form-control" formControlName="email" placeholder="Enter email"  [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required">{{errorMessage}}</div>
                  <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
              </div>
              </div>
              <div class="adjust-div sign-in-button">
                <button type="submit" class="btn btn-primary">Submit</button>
            </div>        </form>
    
          </div>
        </div>
      </div>
    </div>
       </div>